import React from "react";
import store from './store'
import {newRoutes} from "./newRoutes.js";
import { Provider } from 'react-redux'
import { createBrowserHistory } from "history";
import { createBrowserRouter, RouterProvider} from "react-router-dom";
import { createRoot } from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';


import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import "assets/scss/material-kit-pro-react.scss?v=1.8.0";
import 'assets/css/material-dashboard.css';

const hist = createBrowserHistory();

const router = createBrowserRouter(newRoutes);

const theme = createTheme();


const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <RouterProvider router={router}>
      </RouterProvider>
    </ThemeProvider>
  </Provider>);